import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { getFormInstance } from "../graphql/queries";
import { recordSentry } from "./recordSentry";
import { FieldInstance, FormInstance } from "db/definitions";

/**
 * Gets all field instances that belong to a specific FormInstance
 * @param id for the form template by which to retrieve the field templates.
 * @returns all the field templates.
 */
async function getFullFormInstance(id: string) {
	const formInstance = await getBatch(id, null, []);
	return formInstance;
}

async function getBatch(formInstanceId: string, nextToken: string | null, prevItems: FieldInstance[]): Promise<FormInstance | undefined> {
	try {
		const client = generateClient({ authMode: "userPool" });
		interface QueryResult {
			getFormInstance: FormInstance;
		}
		const result = (await client.graphql({
			query: getFormInstance,
			variables: {
				id: formInstanceId,
				nextToken,
			},
			authMode: "userPool",
		})) as unknown as GraphQLResult<QueryResult>;
		const formInstance = result.data.getFormInstance;
		if (formInstance.fieldInstances.nextToken) {
			prevItems = prevItems.concat(formInstance.fieldInstances.items);
			return getBatch(formInstance.id, formInstance.fieldInstances.nextToken, prevItems);
		} else {
			prevItems = prevItems.concat(formInstance.fieldInstances.items);
			formInstance.fieldInstances.items = prevItems;
			return formInstance;
		}
	} catch (error) {
		recordSentry({ error, msg: "Error getting full form instance: " });
	}
}

export default getFullFormInstance;
